export const CREATE_TOAST = 'app/ToastNotificationContainer/CREATE_TOAST';
export const REMOVE_TOAST = 'app/ToastNotificationContainer/REMOVE_TOAST';
export const CLEAR_ALL_TOASTS =
  'app/ToastNotificationContainer/CLEAR_ALL_TOASTS';
